'use strict';

angular
  .module('myConsultApp')
  .factory('TransactionService', function ($resource, ENV, Session, $q) {
    var transactionService = {};

    transactionService.purchaseLocations = [];

    transactionService.getTransactions = function (id, orgId) {
      var user = $resource(
        ENV.apiEndpoint + '/1.0/pets/:id/transactions/?organization_id=' + orgId,
        { id: id },
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return user.get().$promise.then(function (response) {
        return response?.pet || response;
      });
    };

    transactionService.getTransactionsPage = function (url) {
      var transactions = $resource(
        url,
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return transactions.get({}).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getTransaction = function (id) {
      var user = $resource(
        ENV.apiEndpoint + '/2.0/transactions/:id/',
        { id: id },
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return user.get().$promise.then(function (response) {
        return response.transactions;
      });
    };

    transactionService.getdenialReasons = function (url) {
      var reasons = $resource(
        ENV.apiEndpoint + '/1.0/transactions/denial_reasons/',
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return reasons.get({}).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getPurchaseLocations = function (refresh) {
      // if data exists and not a forced refresh return data directly from service
      if (transactionService.purchaseLocations.length > 0 && !refresh) {
        return $q(function (resolve, reject) {
          resolve(transactionService.purchaseLocations);
        });
      }

      // else hit the endpoint to get fresh data
      var locations = $resource(
        ENV.apiEndpoint + '/2.0/transactions/purchase_locations/',
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return locations.get({}).$promise.then(function (response) {
        transactionService.purchaseLocations = response.purchaseLocations;
        return transactionService.purchaseLocations;
      });
    };

    transactionService.addPurchaseLocations = function (data) {
      var locations = $resource(
        ENV.apiEndpoint + '/2.0/transactions/purchase_locations/',
        {},
        {
          save: {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + Session.accessToken },
          },
        },
      );

      return locations.save(data).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.editPurchaseLocation = function (id, data) {
      var locations = $resource(
        ENV.apiEndpoint + '/2.0/transactions/purchase_locations/:id/',
        { id: id },
        {
          save: {
            method: 'PUT',
            headers: { Authorization: 'Bearer ' + Session.accessToken },
          },
        },
      );

      return locations.save(data).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getPetTransactionsAdmin = function (id, orgId) {
      var user = $resource(
        ENV.apiEndpoint + '/1.0/pets/:id/transactions/',
        { id: id },
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return user.get().$promise.then(function (response) {
        return response.pet.transactions;
      });
    };

    transactionService.getUserTransactionsAdmin = function (id) {
      var user = $resource(
        ENV.apiEndpoint + '/1.0/identities/:id/transactions/?pagination=true&page_size=4',
        { id: id },
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return user.get().$promise.then(function (response) {
        return response;
      });
    };

    transactionService.transactionApproval = function (id, status, denyreason, denyNotes) {
      var transactionApproval = $resource(
        ENV.apiEndpoint + '/2.0/transactions/:id/',
        { id: id },
        { update: { method: 'PUT', headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      var updateStatus = { status: status };

      var transaction = {
        transaction: updateStatus,
      };

      if (denyreason != null && denyNotes != null) {
        transaction.transaction.denial_reason = Number(denyreason);
        transaction.transaction.notes = denyNotes;
      } else if (denyreason != null) {
        transaction.transaction.denial_reason = Number(denyreason);
      }

      return transactionApproval.update(transaction).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getPage = function (url) {
      var transactions = $resource(
        url,
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      return transactions.get({}).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getTransactionActivities = function (order, limit, pageno, processed) {
      var user = $resource(
        ENV.apiEndpoint + '/1.0/transaction-activities/',
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      var searchData = {
        order: order,
        page_size: limit,
        page: pageno,
        processed: processed,
      };

      return user.get(searchData).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.getTransactionActivityFiles = function (order, limit, pageno, processed) {
      var user = $resource(
        ENV.apiEndpoint + '/1.0/transaction-activity-files/',
        {},
        { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
      );

      var searchData = {
        order: order,
        page_size: limit,
        page: pageno,
        processed: processed,
      };

      return user.get(searchData).$promise.then(function (response) {
        return response;
      });
    };

    transactionService.retryTransaction = function (id) {
      var retry = $resource(
        ENV.apiEndpoint + '/2.0/transactions/:id/',
        { id: id },
        {
          save: {
            method: 'PUT',
            headers: { Authorization: 'Bearer ' + Session.accessToken },
          },
        },
      );

      return retry.save().$promise.then(function (response) {
        return response;
      });
    };

    transactionService.retryTransactionActivity = function (id) {
      var retry = $resource(
        ENV.apiEndpoint + '/1.0/transaction-activities/:id/',
        { id: id },
        {
          save: {
            method: 'PUT',
            headers: { Authorization: 'Bearer ' + Session.accessToken },
          },
        },
      );

      return retry.save().$promise.then(function (response) {
        return response;
      });
    };

    return transactionService;
  });
